import * as Mod1 from "./discourse/components/bcc-checkbox";
import * as Mod2 from "./discourse/connectors/composer-fields/bcc-checkbox.gjs";
import * as Mod3 from "./discourse/initializers/setup-bcc";
const compatModules = {
  "discourse/components/bcc-checkbox": Mod1,
  "discourse/connectors/composer-fields/bcc-checkbox": Mod2,
  "discourse/initializers/setup-bcc": Mod3,
};
export { compatModules };
export default compatModules;
